module.exports = {"id":"192318","name":"Mario Götze","rating":"83","photo":"./data/images/photos/0/192318.png","club":{"name":"Bor. Dortmund","logo":"./data/images/clubs/Bor.Dortmund.png"},"positions":["MC","MOC","ATT"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarioGotze0.json
// module id = 2780
// module chunks = 0